/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Apply_Fixes_ButtonInputs */



/**
* | output |
* | --- |
* | "Apply Fixes" |
*
* @param {Qc_Apply_Fixes_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_apply_fixes_button = /** @type {((inputs?: Qc_Apply_Fixes_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Apply_Fixes_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer les corrections")
	if (locale === "de") return /** @type {LocalizedString} */ ("Korrekturen anwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica correzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Применить исправления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar correcciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("应用修复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("修正を適用")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सुधार लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar correções")
	return /** @type {LocalizedString} */ ("Apply Fixes")
});